export default class Invoice {
    id: number;
    invoiceNumber?: string;
    collectNumber?: number;
    agreementInHandDate?: Date;
    draftNumber?: number;
    invoiceDueDate?: Date;
    draftDueDate?: Date;
    checkNumber?: number;
    bonusAmount?: number;
    recordingFee?: number;
    rentAmount?: number;
    invoiceTotal?: number;
    bankCharge?: number;
    arDate?: Date;
    paidAmount?: number;
    datePaid?: Date;
    checkSent?: Date;
    collectionType?: string;
    invoiceStatusId?: number;
    checkDate?: Date;
    clientInvoiceNotes?: string;
    invoiceableLookupId?: number;
    otherFee?: number;

    // not mapped
    lessorName?: string;
    leaseNumber?: string;
    projectNumber?: string;
    invoiceStatus?: string;
}



// WEBPACK FOOTER //
// ./src/models/leasing/Invoice.ts